<div class="add-allow-list-user-container">
  <p-dialog [(visible)]="isDialogOpen" [closable]="false" [draggable]="false">
    <ng-template #header>
      <div class="ui-g-11">
        <span>Add Email to Allow List</span>
      </div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closeDialog()"
        (keydown.enter)="closeDialog()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <div class="ui-g dialog-body">
      <div class="ui-g-12">
        <form [formGroup]="addAllowListUserForm">
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">
              Email Address <span class="text-red">*</span>
            </div>
            <div class="ui-g-8">
              <input
                formControlName="emailAddressField"
                class="p-inputtext email-id-textbox p-1 w-100"
                placeholder="Enter Email Address"
                rows="5"
                name="emailAddress"
                aria-label="emailAddress"
                autocomplete="nope"
                type="email"
                [email]="true"
                [ngClass]="{
                  'error-box':
                    addAllowListUserFormControls['emailAddressField'].errors &&
                    addAllowListUserFormControls['emailAddressField'].touched
                }" />
            </div>
          </div>
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">
              Fullname <span class="text-red">*</span>
            </div>
            <div class="ui-g-8">
              <input
                formControlName="fullNameField"
                class="p-inputtext full-name-textbox p-1 w-100"
                placeholder="Enter Fullname"
                rows="5"
                name="fullName"
                aria-label="fullName"
                autocomplete="nope"
                [ngClass]="{
                  'error-box':
                    addAllowListUserFormControls['fullNameField'].errors &&
                    addAllowListUserFormControls['fullNameField'].touched
                }" />
            </div>
          </div>
          <div class="mb-3 ui-g">
            <div class="title ui-g-4">
              Partner ID <span class="text-red">*</span>
            </div>
            <div class="ui-g-8">
              <input
                formControlName="mpnIdField"
                class="p-inputtext mpnid-email-textbox p-1 w-100"
                placeholder="Enter Partner ID"
                rows="5"
                name="mpnId"
                aria-label="mpnId"
                autocomplete="nope"
                [ngClass]="{
                  'error-box':
                    addAllowListUserFormControls['mpnIdField'].errors &&
                    addAllowListUserFormControls['mpnIdField'].touched
                }" />
            </div>
          </div>
          <div class="mb-3 ui-g">
            @if (canShowForceAdd) {
              <div>
                <label for="forceAddOrUpdateCheckbox">Force Add/Update</label>
                <p-checkbox
                  id="forceAddOrUpdateCheckbox"
                  [(ngModel)]="isForceAddOrUpdate"
                  formControlName="isForceAddOrUpdateField"
                  [binary]="true"></p-checkbox>
              </div>
            }
          </div>
          <div>
            @if (!isLoading) {
              <div class="float-right">
                <button
                  type="button"
                  pTooltip="Ok"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr button-ok"
                  pButton
                  (click)="onSubmitUserInformation()"
                  [disabled]="addAllowListUserForm.invalid">
                  Ok
                </button>
                <button
                  type="button"
                  pTooltip="Cancel"
                  (click)="closeDialog()"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr button-cancel"
                  pButton>
                  Cancel
                </button>
              </div>
            }
          </div>
        </form>
      </div>

      <div class="ui-g-12">
        @for (message of inlineMessage; track message) {
          <p-message [life]="3000" [text]="message.detail"></p-message>
        }
      </div>
    </div>
  </p-dialog>
</div>
